/**
 * Converts bytes to an object url that can be displayed in the browser or downloaded.
 * A mimeType can also be provided.
 *
 * **NOTE**: The url holds the bytes alive until it is revoked.
 * It is the caller's responsibility to release it when no longer needed.
 */
export function bytesToObjectURL (bytes: string | Uint8Array, mimeType?: string): string {
  const blob = new Blob([bytes as BlobPart], { type: mimeType })
  return URL.createObjectURL(blob)
}

const LOCAL_CLUSTER_URL = 'http://policyfly-frontend.local.svc.cluster.local:8080/'
/**
 * Parses a url, replacing local urls with the cluster.
 */
export function parseUrl (url: string): string {
  return url.trim()
    .replace(/^http:\/\/localhost:\d+\//, LOCAL_CLUSTER_URL) // localhost:XXXX
    .replace(/^http:\/\/\d+\.\d+\.\d+\.\d+:\d+\//, LOCAL_CLUSTER_URL) // XXX.XXX.XXX.XXX:XXXX
}
